import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/product_categories'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataListLow: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      title: null,
      summary: null,
      content: null,
      status: null,
      id_product_categories: null,
      slug: null,
      ordering: null,
      submitStatus: false,
      images: [],
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataListLow(state) {
      return state.dataListLow
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_LIST_LOW(state, data) {
      state.dataListLow = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state, data) {
      if (data) {
        state.dataItem = {
          id: null,
          title: null,
          summary: null,
          content: null,
          id_product_categories: null,
          slug: null,
          ordering: null,
          status: null,
          submitStatus: false,
          images: [],
        }
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataList2({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST_LOW', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'product_categories.id': id,
        },
        array: false,
      })
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          const itemData = response.data.data || {}
          // Ensure images is always an array
          if (!itemData.images || !Array.isArray(itemData.images)) {
            itemData.images = []
          }
          commit('SET_DATA_ITEM', itemData)
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      // Ensure images is always an array to prevent backend foreach errors
      const dataToSave = { ...postData }
      if (!dataToSave.images || !Array.isArray(dataToSave.images)) {
        dataToSave.images = []
      }
      const data = JSON.stringify(dataToSave)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    saveImage({ commit }, data) {
      axiosIns
          .post(`${ROOT_URL}/saveImage`, data)
          .then(response => {
            commit('SET_DATA_SAVE', response.data)
          })
          .catch(error => console.error(error))
    },
    removeImageData({ commit }, postData) {
      // const data = JSON.stringify(postData)
      axiosIns
          .post(`${ROOT_URL}/deleteImage`, { postData })
          .then(response => {
            commit('SET_DATA_SAVE', response.data)
          })
          .catch(error => console.error(error))
    },
    reOrderingImages({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
          .post(`${ROOT_URL}/reOrderingImages`, data)
          .then(response => {
            // commit('SET_DATA_SAVE', response.data)
          })
          .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    resetDataItem({ commit }) {
      commit('RESET_DATA_ITEM', true)
    },
  },
}
